import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import Header from "./Components/Layout/Header";
import Footer from "./Components/Layout/Footer";
import ScrollToTopButton from "./Components/Layout/ScrollToTopButton";
import { useEffect, useState } from "react";
import ScrollTopButton2 from "./Components/Layout/ScrollToTopButton2";
import { CartProvider } from "./Context/CartContext";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <CartProvider>
        <Header />

        <App />
        <Footer />
      </CartProvider>
      {/* <ScrollToTopButton /> */}
      <ScrollTopButton2 />
    </BrowserRouter>
  </React.StrictMode>,
);

reportWebVitals();
